import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

let user = JSON.parse(localStorage.getItem("user"));

if (user) {
  axios.defaults.headers.common = {
    Authorization: "Bearer " + user.token,
  };
}

axios.interceptors.response.use(
  (res) => {
    if (res.data && res.data.errorCode === 502) {
      localStorage.setItem("isPlanExpired", "true");
      window.location.hash = "/societyadmin/dashboard";
    }

    if (res.data && res.data.errorCode === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("isPlanExpired");
      document.cookie = "iss_logged_in=; path=/; domain=.ismartsociety.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax; Secure";
      if (typeof BroadcastChannel !== 'undefined') {
        try { const bc = new BroadcastChannel('iss_auth'); bc.postMessage('logout'); bc.close(); } catch (e) { console.error(e); }
      }
      window.location.href = "/societyadmin/login";
    }
    return res;
  },
  (error) => {
    if (error.response && error.response.data && error.response.data.errorCode === 401) {
      localStorage.removeItem("user");
      document.cookie = "iss_logged_in=; path=/; domain=.ismartsociety.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax; Secure";
      if (typeof BroadcastChannel !== 'undefined') {
        try { const bc = new BroadcastChannel('iss_auth'); bc.postMessage('logout'); bc.close(); } catch (e) { console.error(e); }
      }
      window.location.href = "/societyadmin/login";
    }
    return Promise.reject(error);
  }
);

export default axios;